module.exports = __webpack_public_path__ + "img/background_c3-1_mask_mobile.ba294c0a.jpg";